import {
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Link,
  List,
  ListItem,
  ListItemText,
  Paper,
  Radio,
  Typography,
} from '@material-ui/core';
import { unstable_Box as Box } from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import { mdiCashRegister, mdiCreditCard } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import { connect } from 'react-redux';

import { AccountWallet } from '@aps-management/primapp-common';

import i18n from '_utils/i18n';
import masterClient from '_utils/masterClient';

const styles = {
  item: { paddingLeft: 6 },
  balance: {
    fontWeight: 100,
    fontSize: 20,
  },
};

const isWalletValidForPayment = (wallet, amount) => {
  if (!wallet) return false;

  const { balance, creditLimit } = wallet;
  if (creditLimit === null) return true;

  const remainingBalance = balance - amount;
  return remainingBalance >= -1 * creditLimit;
};

class PaymentMethods extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      wallet: null,
      acceptTerms: false,
      isWalletLoading: false,
      isWalletValid: true,
    };
  }

  componentDidMount() {
    const {
      account,
      golf,
      amount,
      methods,
      selected,
      onChange,
    } = this.props;

    // Check si le client a un compte client
    if (methods.includes(2)) {
      this.setState({ isWalletLoading: true });

      AccountWallet.api
        .get(masterClient, {
          golfId: golf.id,
          accountId: account.id,
        })
        .then((wallet) => {
          this.setState({ wallet });

          const isWalletValid = isWalletValidForPayment(wallet, amount);
          this.setState({ isWalletValid });

          // Auto-select wallet if it's the currently selected method
          // (e.g. when it's the only available option). This ensures
          // paymentMethodOpts is populated without requiring a click.
          if (selected === 2) {
            if (isWalletValid) {
              onChange(2, { wallet });
            } else if (methods.length === 1) {
              // Wallet is the only option but is invalid: deselect it
              onChange(null, {});
            }
          }
        })
        .catch(() => null) // Pas de compte client, tant pis !
        .finally(() => this.setState({ isWalletLoading: false }));
    }
  }

  handleChangeAcceptTerms = (event) => {
    const { onChangeAcceptTerms } = this.props;

    this.setState({ acceptTerms: event.target.checked });
    if (onChangeAcceptTerms) onChangeAcceptTerms(event.target.checked);
  };

  renderWalletMethod() {
    const { classes, amount, selected, onChange } = this.props;
    const { wallet, isWalletValid } = this.state;

    if (!wallet) return null;

    const disabled = !isWalletValid;
    const remainingBalance = wallet.balance - amount;

    let color = 'primary';
    let secondary = (
      <Typography variant='caption' color={color}>
        {`Futur solde : ${i18n.l('currency', remainingBalance / 100)}`}
      </Typography>
    );
    if (!isWalletValid) {
      color = 'error';
      secondary = (
        <Typography variant='caption' color={color}>
          {"Vous n'avez pas les fonds suffisants."}
        </Typography>
      );
    }

    return (
      <ListItem
        button
        divider
        disableRipple
        disabled={disabled}
        className={classes.item}
        onClick={() => onChange(2, { wallet })}
      >
        <Radio tabIndex={-1} disabled={disabled} checked={selected === 2} />
        <ListItemText primary='Payer par compte client' secondary={secondary} />
        <Typography color={color} className={classes.balance}>
          {i18n.l('currency', wallet.balance / 100)}
        </Typography>
      </ListItem>
    );
  }

  render() {
    const { classes, methods, selected, onChange } = this.props;
    const { acceptTerms, isWalletLoading, isWalletValid } = this.state;

    if (isWalletLoading) {
      return (
        <Box display='flex' justifyContent='center' alignItems='center' minHeight='200px'>
          <CircularProgress size={24} color='secondary' />
        </Box>
      );
    }

    const AcceptLabel = (
      <Typography>
        {"J'ai lu et j'accepte les "}
        <Link rel='noopener' target='_blank' color='textSecondary' href='/terms-conditions'>
          {"Conditions générales d'utilisation."}
        </Link>
      </Typography>
    );

    return (
      <Box>
        <Paper>
          <List disablePadding>
            {methods.includes(0) && (
              <ListItem button divider disableRipple onClick={() => onChange(0, {})} className={classes.item}>
                <Radio tabIndex={-1} checked={selected === 0} />
                <ListItemText primary='Payer par carte bancaire' />
                <Icon path={mdiCreditCard} size={1.5} />
              </ListItem>
            )}
            {methods.includes(1) && (
              <ListItem button divider disableRipple onClick={() => onChange(1, {})} className={classes.item}>
                <Radio tabIndex={-1} checked={selected === 1} />
                <ListItemText primary='Payer sur place' secondary="Présentez vous à l'accueil pour régler" />
                <Icon path={mdiCashRegister} size={1.5} />
              </ListItem>
            )}
            {this.renderWalletMethod()}
          </List>
        </Paper>
        <Box mt={2}>
          <FormControlLabel
            control={
              <Checkbox
                value='1'
                name='acceptTerms'
                color='secondary'
                checked={acceptTerms}
                disabled={selected === 2 && !isWalletValid}
                className={classes.checkboxCtrl}
                onChange={this.handleChangeAcceptTerms}
              />
            }
            label={AcceptLabel}
          />
        </Box>
      </Box>
    );
  }
}

const mapStateToProps = ({ app }) => ({
  golf: app.golf,
  account: app.account,
});
const StyledComponent = withStyles(styles)(PaymentMethods);

export default connect(mapStateToProps)(StyledComponent);
